<h6 class="font-semibold mb-1">{{ '#UTILITIES.USER_CONTEXT.LABEL' | translate }}</h6>
<ng-container>
  <div class="c row space-between">
    <span>{{ (userContext$ | async)?.userFullName }}</span>
  </div>
</ng-container>
